<template>
    <b-datatable
        ref="grid"
        :columns="columns"
        :endpoint="listRoute"
        :hidden-columns="hiddenColumns"
        :initial-filters="initialFilters"
        class="search-data-table"
        :grid-title="gridTitle"
        :datatable-key="datatableKey"
        has-filter-selector
        @update-filters="updateFilters"
    >
        <template #filters="{ filters }">
            <v-col cols="3" class="pb-0">
                <b-filter-input
                    v-model="filters.filters.query"
                    :label="t('search::filter.label.search_term')"
                ></b-filter-input>
            </v-col>

            <v-col cols="3" class="pb-0">
                <b-filter-select
                    v-model="filters.filters.entities"
                    :items="filtersOptions.entities"
                    :label="t('search::filter.label.entity')"
                    :clearable="filters.filters.entities !== null"
                >
                </b-filter-select>
            </v-col>
        </template>

        <template #[`item.name`]="{ item }">
            <div v-if="can(`${item.type.replace('_', '-')}s.get`)" class="link" @click="$root.goTo(itemUrl(item))">
                {{ item.name }}
            </div>
            <div v-else>
                {{ item.name }}
            </div>
        </template>
        <template #[`item.type`]="{ item }">
            <div class="grid-status">
                <span>
                    {{ t(`search::types.${item.type}`) }}
                </span>
            </div>
        </template>

        <template #[`item.data`]="{ item }">
            <component
                :is="`search-bar-item-${item.type}`"
                :item="item"
                :query="queryString"
                :is-grid="true"
            ></component>
        </template>

        <template #[`item.actions`]="{ item }">
            <div class="table-actions">
                <v-tooltip
                    v-if="
                        can(`api.v1.${item.type.replace('_', '-')}s.store`) &&
                        can(`${item.type.replace('_', '-')}s.create`)
                    "
                    top
                    transition="v-fab-transition"
                >
                    <template #activator="{ on, attrs }">
                        <v-btn
                            color="disabled-color"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="$root.goTo(editItemUrl(item))"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ t('default::button.edit') }}</span>
                </v-tooltip>

                <v-tooltip
                    v-if="
                        !can(`api.v1.${item.type.replace('_', '-')}s.update`) &&
                        can(`${item.type.replace('_', '-')}s.show`)
                    "
                    top
                    transition="v-fab-transition"
                >
                    <template #activator="{ on, attrs }">
                        <v-btn
                            color="disabled-color"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="$root.goTo(editItemUrl(item))"
                        >
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ t('default::button.details') }}</span>
                </v-tooltip>
            </div>
        </template>
    </b-datatable>
</template>
<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
        initialFilters: {
            type: Object,
            required: true,
        },
        gridTitle: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            datatableKey: 0,
            hiddenColumns: ['id'],
            queryString: this.initialFilters.query,
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('search::grid.label.type'),
                    value: 'type',
                    sortable: false,
                    width: 160,
                },
                {
                    text: t('search::grid.label.name'),
                    value: 'name',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('search::grid.label.details'),
                    value: 'data',
                    sortable: false,
                    width: 520,
                },
                {
                    text: t('default::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: null,
                    width: 100,
                    align: 'end',
                },
            ],
            filtersOptions: {
                entities: [
                    {
                        text: t('default::options.all'),
                        value: null,
                    },
                    {
                        text: t('search::types.patient'),
                        value: 'patient',
                    },
                    {
                        text: t('search::types.consultant'),
                        value: 'consultant',
                    },
                    {
                        text: t('search::types.pharmacy_site'),
                        value: 'pharmacy_site',
                    },
                ],
            },
        };
    },
    created() {},
    methods: {
        consultantItemUrl(item) {
            return route('consultants.get', { id: item.id });
        },
        editItemUrl(item) {
            return route(`${item.type.replace('_', '-')}s.get`, { id: item.id });
        },
        itemUrl(item) {
            return route(`${item.type.replace('_', '-')}s.get`, { id: item.id });
        },
        updateFilters(filters) {
            if (filters.query !== this.queryString) {
                this.queryString = filters.query;
                this.$store.dispatch('search/setQueryString', filters.query);
                this.datatableKey++;
            }
        },
    },
};
</script>
